import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Jumbo } from "../components/jumbo";
import CollectionSearchBar from "../components/collection_search_bar";
import { BlockRenderer } from "../components/block_renderer";
import { SearchBarWrapper } from "../components/search_bar";
const collectionPageStateZero = {};
export class CollectionPage extends React.Component {
    updateInput(i, c) {
        this.setState((s, _)=>({
                ...s,
                input: i
            }), c);
    }
    render() {
        const p = this.props;
        const s = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: "collection-page",
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: p.headerTitle,
                    contents: p.description,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    size: "small",
                    kind: "collection"
                }),
                /*#__PURE__*/ _jsx(SearchBarWrapper, {
                    children: /*#__PURE__*/ _jsx(CollectionSearchBar, {})
                }),
                /*#__PURE__*/ _jsx(BlockRenderer, {
                    blocks: p.blocks
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = collectionPageStateZero;
        this.updateInput = this.updateInput.bind(this);
        document.title = this.props.pageTitle;
    }
}
{}